import axios from 'axios';

// 기존 axiosInstance.ts와 동일한 baseURL 패턴 사용
// (환경변수명: REACT_APP_BACKEND_URL, API 경로에 /api/v1 포함)
const BASE_URL =
  process.env.NODE_ENV === 'production' ? process.env.REACT_APP_BACKEND_URL || '' : '';

const nhisPublicAxios = axios.create({
  baseURL: BASE_URL,
  timeout: 60000, // 60초 (Octover 스크래핑 대기)
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: false, // JWT 쿠키 불필요
});

export default nhisPublicAxios;
